import styled from 'styled-components';
import { IoMdCloseCircle } from 'react-icons/io';
import { Button } from 'reactstrap';

export const FileSelectorWrapper = styled.div`
  width: 100%;
  margin-top: 10px;

  .audio-button-select-style {
    height: 30px;
    width: 100%;
    max-width: 300px;
    border-radius: 15px;
    ${(props) => props.color && `background: ${props.color};`}
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-family: Roboto, sans-serif;
    margin-top: 10px;
    border: 0;
    cursor: pointer;

    &&:focus {
      border: 0;
    }
  }
`;

export const AttachmentContainer = styled.div`
  margin-left: 1rem;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  align-content: flex-start;
`;

export const AttachmentNameContainer = styled.div`
  position: relative;
  width: 18rem;
  padding: 0.5rem;
  line-height: 1rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 1.5rem;

  &:hover {
    background-color: #f5f5f5;
  }

  &:hover .delete-icon {
    display: inline-block;
  }
`;

export const DeleteIcon = styled(IoMdCloseCircle)`
  display: none;
  position: absolute;
  right: 0.5rem;
  top: 0.75rem;
`;

export const AttachmentImage = styled.img`
  display: inline-block;
  margin-right: 0.5rem;
`;

export const AttachmentLink = styled.a`
  display: inline-block;
  margin-right: 0.5rem;
`;

export const ClearButton = styled(Button)`
  margin-left: 0.5rem;
`;

export const UploadButton = styled(Button)`
  margin-left: 0.5rem;
`;
